import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_REASSIGN_THERAPIST,
  SUCCESS_REASSIGN_THERAPIST,
  FAILURE_REASSIGN_THERAPIST,
  LOADING_REASSIGN_THERAPIST,
} = documentationActions;

function* reAssignTherapist(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_REASSIGN_THERAPIST });
    const response = yield call(
      templateService.reAssignTherapist,
      action.documentUuid,
      action.providerId
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_REASSIGN_THERAPIST, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_REASSIGN_THERAPIST, payload: error });
  }
}

function* reAssignTherapistSaga() {
  yield takeEvery(REQUEST_REASSIGN_THERAPIST, reAssignTherapist);
}

export default reAssignTherapistSaga;
